// mobile nav init
export default function initMobileNav(container = document) {
    const body = document.body;
    const navActive = 'nav-active';

    const navbBar = container.querySelector('.mega-menu');
    const navOpener = container.querySelector('.nav-opener');
    const navClose = container.querySelector('.nav-close');
    const links = navbBar.querySelectorAll('a');
    navOpener.setAttribute('aria-expanded', 'false');

    links.forEach(elem => {
        elem.setAttribute('tabIndex', '-1');
    });

    // Global open/close functions
    const open = () => {
        body.classList.add(navActive);
        navOpener.setAttribute('aria-expanded', 'true');

        links.forEach(elem => {
            elem.removeAttribute('tabIndex');
        });
    }

    const close = () => {
        body.classList.remove(navActive);
        navOpener.setAttribute('aria-expanded', 'false');

        links.forEach(elem => {
            elem.setAttribute('tabIndex', '-1');
        });
    }

    if (navbBar) {
        // Check click on button
        navOpener.addEventListener('click', (e) => {
            e.preventDefault();
            if (!body.classList.contains(navActive)) {
                open();
            } else {
                close();
            }
        });

        if (navClose) {
            navClose.addEventListener('click', (e) => {
                e.preventDefault();
                close();
            });
        }

        // Close when user click outside
        body.addEventListener('click', (e) => {
            if (!navOpener.contains(e.target) && !navbBar.contains(e.target)) {
                close();
            }
        });
    }

    // Close nav when a link is clicked
    const navLinks = container.querySelectorAll('.mega-menu a');

    if (navLinks) {
        navLinks.forEach((link) => {
            link.addEventListener('click', () => {
                close();
            });
        });
    }

    if (navbBar) {
        document.onkeydown = (evt) => {
            var evt = evt || window.event;
            if (evt.keyCode == 27) {
                if (body.classList.contains(navActive)) {
                    close();
                }
            }
        };
    }

    // menu focus init
    window.addEventListener('keydown', handleKey);

    function handleKey(e) {
        if (e.keyCode === 9) {
            if (links.length) {
                let first = links[0];
                let last = links[links.length - 1];
                let shift = e.shiftKey;
                if (shift) {
                    if (e.target === first) {
                        last.focus();
                        e.preventDefault();
                    }
                } else {
                    if (e.target === last) {
                        first.focus();
                        e.preventDefault();
                    }
                }
            }
        }
    }
}